export enum ECP_OFFER_DOCUMENTS_TABLE_KEYS {
  DocumentName = 'Dokumentname',
  Type = 'Typ',
  Service = 'Service',
  DateTime = 'Erstellt am',
  SentAt = 'Versendet am',
  Actions = 'Aktionen'
}

export interface ICPOfferDocumentsTableItem {
  [ECP_OFFER_DOCUMENTS_TABLE_KEYS.DocumentName]: string
  [ECP_OFFER_DOCUMENTS_TABLE_KEYS.Service]: string
  [ECP_OFFER_DOCUMENTS_TABLE_KEYS.DateTime]: string | string[]
  [ECP_OFFER_DOCUMENTS_TABLE_KEYS.SentAt]: string | string[]
  [ECP_OFFER_DOCUMENTS_TABLE_KEYS.Actions]: number
}

export interface ICPOfferDocumentsTableProps {
  data: ICPOfferDocumentsTableItem[]
  loading?: boolean
  disabled?: boolean
  noDataText?: string
  canDelete?: boolean
}
